<template>
  <base-section
    id="organizing-committee"
  >
    <!---
    <base-section-heading title="Organizing Committee">
    </base-section-heading>
    --->
    <v-container>
      <v-row>
        <base-avatar-card
          title="General Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(general, i) in generals"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="general"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Fringe Workshops Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(fringe, i) in fringes"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="fringe"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <!---
      <v-row>
            <base-avatar-card
            title="Program Chair"
            align="left"
            horizontal
          >
          </base-avatar-card>
        </v-row>
      <v-row>
        <v-col
          v-for="(program, i) in programs"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="program"
            align="left"
            horizontal
          >
          </base-avatar-card>
        </v-col>
      </v-row>
      --->
      <v-row>
        <base-avatar-card
          title="Publicity Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(publicity, i) in publicities"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="publicity"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Finance Chair"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(finance, i) in finances"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="finance"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Regional Liaison Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(regional, i) in regionals"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="regional"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Student Activities Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(studentact, i) in studentacts"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="studentact"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Industry Link Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(industry, i) in industries"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="industry"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Awards Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(award, i) in awards"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="award"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="PhD Contest Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(contest, i) in contests"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="contest"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="PhD Forum Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(forum, i) in forums"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="forum"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Publication Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(publication, i) in publications"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="publication"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Virtualization Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(virtual, i) in virtuals"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="virtual"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Web Resource Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(web, i) in webs"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="web"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in committeesfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < committeesfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'OrganizingCommittee',

    data: () => ({
      isMobile: false,
      committeesfooter: [
        {
          name: 'Program Chair',
          url: 'program-committee',
        },
        {
          name: 'Topic Chairs',
          url: 'topic-chairs',
        },
        {
          name: 'Program Committee Members',
          url: 'members',
        },
        {
          name: 'Program Committee Companions',
          url: 'companions',
        },
        {
          name: 'Industrial Board',
          url: 'industrial',
        },
        {
          name: 'Organizing Committee',
          url: 'organizing-committee',
        },
      ],
      generals: [
        {
          title: 'Paolo Bernardi',
          src: require('@/images/committees/paolobernardi.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Daniel Tille',
          src: require('@/images/committees/danieltille.jpg'),
          text: 'Infineon, DE',
        },
      ],
      publicities: [
        {
          title: 'Alexandra Kourfali',
          src: require('@/images/committees/alexandrakourfali.jpg'),
          text: 'ITI Stuttgart, DE',
        },
        {
          title: 'Giorgio Di Natale',
          src: require('@/images/committees/giorgiodinatale.jpg'),
          text: 'TIMA, FR',
        },
      ],
      regionals: [
        {
          title: 'Sule Ozev',
          src: require('@/images/committees/suleozev.jpg'),
          text: 'Arizona State University, USA',
        },
        {
          title: 'Ernesto Sanchez',
          src: require('@/images/committees/ernestosanchez.jpg'),
          text: 'Politecnico di Torino, IT',
        },
      ],
      studentacts: [
        {
          title: 'Maria Michael',
          src: require('@/images/committees/mariamichael.jpeg'),
          text: 'University of Cyprus, CY',
        },
        {
          title: 'Maksim Jenihhin',
          src: require('@/images/committees/maksim.jpeg'),
          text: 'Taltech, EE',
        },
      ],
      industries: [
        {
          title: 'Davide Appello',
          src: require('@/images/committees/davideappello.jpg'),
          text: 'STMicroelectronics, IT',
        },
        {
          title: 'Souhir Mhira',
          src: require('@/images/committees/souhir.jpg'),
          text: 'Dolphin Design, FR',
        },
      ],
      contests: [
        {
          title: 'Anne Meixner',
          src: require('@/images/committees/meixner.jpg'),
          text: 'ENG.DAUGHTERS, US',
        },
        {
          title: 'Arnaud Virazel',
          src: require('@/images/committees/arnaud.jpg'),
          text: 'LIRMM, FR',
        },
      ],
      forums: [
        {
          title: 'Angeliki Kritikakou',
          src: require('@/images/committees/kritikakou.jpg'),
          text: 'Rennes University, FR',
        },
        {
          title: 'Paolo Rech',
          src: require('@/images/committees/rech.jpg'),
          text: 'Trento University, IT',
        },
      ],
      awards: [
        {
          title: 'Liviu Miclea',
          src: require('@/images/committees/miclea.jpg'),
          text: 'CLUJ-NAPOCA University, RO',
        },
        {
          title: 'Sybille Hellebrand',
          src: require('@/images/committees/Hellebrand.jpg'),
          text: 'Paderborn University, DE',
        },
      ],
      publications: [
        {
          title: 'Mottaqiallah Taouil',
          src: require('@/images/committees/taouil.jpg'),
          text: 'TU Delft, NL',
        },
        {
          title: 'Tara Ghasempuori',
          src: require('@/images/committees/ghasempouri.jpg'),
          text: 'Taltech, EE',
        },
      ],
      fringes: [
        {
          title: 'Alessandro Savino',
          src: require('@/images/committees/alessandrosavino.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Yanjing Li',
          src: require('@/images/committees/Li.jpg'),
          text: 'University of Chicago, US',
        },
      ],
      finances: [
        {
          title: 'Bastien Deveautour',
          src: require('@/images/committees/bastien.jpg'),
          text: 'INL/CPE, FR',
        },
      ],
      virtuals: [
        {
          title: 'Stefano Di Carlo',
          src: require('@/images/committees/stefanodicarlo.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Tommaso Foscale',
          src: require('@/images/committees/tommasofoscale.jpg'),
          text: 'Politecnico di Torino, IT',
        },
      ],
      webs: [
        {
          title: 'Giusy Iaria',
          src: require('@/images/committees/giusyiaria.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Sebastian Huhn',
          src: require('@/images/phdcontestwinner.png'),
          text: 'University of Bremen, DE',
        },
        {
          title: 'Nicolò Bellarmino',
          src: require('@/images/committees/nicolobellarmino.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Andrea Calabrese',
          src: require('@/images/committees/andreacalabrese.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Gabriele Filipponi',
          src: require('@/images/committees/gabrielefilipponi.jpg'),
          text: 'Politecnico di Torino, IT',
        },
        {
          title: 'Francesco Angione',
          src: require('@/images/committees/francescoangione.jpg'),
          text: 'Politecnico di Torino, IT',
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
